export default __webpack_public_path__ + "static/cyber-blindspot-e890a0d983f68bb7f6ece29cbdc6961d.png";